const translations = {
    'resource.bricks': 'bricks',
    'resource.charcoal': 'charcoal',
    'resource.clothRope': 'cloth/rope',
    'resource.coins': 'coins',
    'resource.fiber': 'fiber',
    'resource.fish': 'fish',
    'resource.food': 'food',
    'resource.gold': 'gold',
    'resource.goldOre': 'gold ore',
    'resource.ironIngots': 'iron ingots',
    'resource.ironOre': 'iron ore',
    'resource.leather': 'leather',
    'resource.planks': 'planks',
    'resource.stone': 'stone',
    'resource.tools': 'tools',
    'resource.trees': 'trees',
    'resource.weapons': 'weapons',
    'resource.wild_life': 'wildlife',
    'resource.wood': 'wood',
};

export default translations;
